import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILED,
  EDIT_NOTIFICATIONS,
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_FAILED,
} from "../store/types";

import { store } from "../store/store";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { cloud_function_server_url, language } from '../../config';

const END_POINT = `${cloud_function_server_url}/notifications`;

export const fetchNotifications = () => (dispatch) => (firebase) => {

  const {
    notifyRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });

  fetch(`${END_POINT}/fetch-notifications`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      if (response?.success) {
        const arr = response.data?.map((item) => {
          item.id = item._id;
          return item;
        })
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_NOTIFICATIONS_FAILED,
          payload: "No data available."
        });
      }
    }).catch(error => {
      dispatch({
        type: FETCH_NOTIFICATIONS_FAILED,
        payload: "No data available."
      });
      console.log("fetchNotifications error", error)
    });
};

export const addNotifications = (notifications) => (dispatch) => (firebase) => {
  dispatch({
    type: EDIT_NOTIFICATIONS,
    payload: { method: "Add", notifications }
  });

  fetch(`${END_POINT}/add-notification`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ data: notifications })
  })
    .then(async (res) => {
      const response = await res.json();
      if(response?.success) {
        fetchNotifications()(dispatch)(firebase);
      }
      console.log("response", response)
    }).catch(error => {
      console.log("res check error", error)
    });
}

export const editNotifications = (notifications) => (dispatch) => (firebase) => {
  dispatch({
    type: EDIT_NOTIFICATIONS,
    payload: { method: "Update", notifications }
  });

  fetch(`${END_POINT}/edit-notification/${notifications.id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ data: {usertype: notifications.usertype, title: notifications.title, body: notifications.body} })
  })
    .then(async (res) => {
      const response = await res.json();
      if(response?.success) {
        fetchNotifications()(dispatch)(firebase);
      }
      console.log("response", response)
    }).catch(error => {
      console.log("res check error", error)
    });
}


export const deleteNotifications = (notifications) => (dispatch) => (firebase) => {
  dispatch({
    type: EDIT_NOTIFICATIONS,
    payload: { method: "Delete", notifications }
  });

  fetch(`${END_POINT}/delete-notification/${notifications.id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      if(response?.success) {
        fetchNotifications()(dispatch)(firebase);
      }
      console.log("response", response)
    }).catch(error => {
      console.log("res check error", error)
    });
}

// export const editNotifications = (notifications, method) => (dispatch) => (firebase) => {

//   const {
//     notifyRef,
//     notifyEditRef
//   } = firebase;

//   dispatch({
//     type: EDIT_NOTIFICATIONS,
//     payload: { method, notifications }
//   });
//   if (method === 'Add') {
//     notifyRef.push(notifications);
//   } else if (method === 'Delete') {
//     notifyEditRef(notifications.id).remove();
//   } else {
//     notifyEditRef(notifications.id).set(notifications);
//   }
// }

export const sendNotification = (notification) => (dispatch) => (firebase) => {
  console.log("notification check", notification)
  dispatch({
    type: SEND_NOTIFICATION,
    payload: notification
  });

  fetch(`${END_POINT}/send-notification`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ data: notification })
  })
    .then(async (res) => {
      const response = await res.json();
      if (response?.success) {
        console.log("response", response)
        dispatch({
          type: SEND_NOTIFICATION_SUCCESS,
          payload: response.data
        });
      } else {
        dispatch({
          type: SEND_NOTIFICATION_FAILED,
          payload: language.no_user_match,
        });
      }
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: SEND_NOTIFICATION_FAILED,
        payload: language.no_user_match,
      });
    });

  // let users = store.getState().usersdata.users;
  // let arr = [];
  // for (let i = 0; i < users.length; i++) {
  //   let usr = users[i];
  //   let obj = {
  //     "to": null,
  //     "title": notification.title,
  //     "msg": notification.body,
  //   };
  //   if (notification.usertype === 'All' && notification.devicetype === 'All') {
  //     if (usr.pushToken) {
  //       obj.to = usr.pushToken;
  //       arr.push(obj);
  //     }
  //   } else if (notification.usertype === 'All' && notification.devicetype !== 'All') {
  //     if (usr.pushToken && usr.userPlatform === notification.devicetype) {
  //       obj.to = usr.pushToken;
  //       arr.push(obj);
  //     }
  //   } else if (notification.usertype !== 'All' && notification.devicetype === 'All') {
  //     if (usr.pushToken && usr.usertype === notification.usertype) {
  //       obj.to = usr.pushToken;
  //       arr.push(obj);
  //     }
  //   } else {
  //     if (usr.pushToken && usr.usertype === notification.usertype && usr.userPlatform === notification.devicetype) {
  //       obj.to = usr.pushToken;
  //       arr.push(obj);
  //     }
  //   }
  // }

  // if (arr.length > 0) {
  //   for (let x = 0; x < arr.length; x++) {
  //     RequestPushMsg(arr[x].to, arr[x].title, arr[x].msg)
  //   }
  //   dispatch({
  //     type: SEND_NOTIFICATION_SUCCESS,
  //     payload: arr
  //   });
  // } else {
  //   dispatch({
  //     type: SEND_NOTIFICATION_FAILED,
  //     payload: language.no_user_match,
  //   });
  // }
}